"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const Check = (props) => {
    const { width = '32px', height = '32px' } = props;
    return (react_1.default.createElement(react_native_svg_1.Svg, { width: width, height: height, viewBox: "0 0 32 32" },
        react_1.default.createElement(react_native_svg_1.G, { fill: "none", "fill-rule": "evenodd" },
            react_1.default.createElement(react_native_svg_1.G, null,
                react_1.default.createElement(react_native_svg_1.G, null,
                    react_1.default.createElement(react_native_svg_1.G, null,
                        react_1.default.createElement(react_native_svg_1.Path, { fill: "#000", "fill-opacity": "0", d: "M0 0H32V32H0z", transform: "translate(-999 -510) translate(712 469) translate(287 41)" }),
                        react_1.default.createElement(react_native_svg_1.G, { stroke: "#008F00", "stroke-linecap": "square" },
                            react_1.default.createElement(react_native_svg_1.Path, { d: "M0 4.8L6 10.8 16.8 0", transform: "translate(-999 -510) translate(712 469) translate(287 41) translate(7.6 10.6)" }))))))));
};
exports.default = react_1.default.memo(Check);
